<nav class="navbar sticky-top navbar-expand-lg navbar-dark" style="background-color: rgba(14, 110, 110);">

        <a class="navbar-brand">
                Pepiniera Volintir

        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span><img class="menuicon" src="/assets/logo/website_logo_transparent_background.png" width="100px"
                                height="100px" alt=""></span>
        </button>

        <div class="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">
                <ul class="navbar-nav ">
                        <li class="nav-item active" data-toggle="collapse" data-target="#navbarSupportedContent">
                                <a class="nav-link" routerLink="">Acasa</a>
                        </li>
                        <li class="nav-item dropdown ">
                                <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Produse
                                </a>
                                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                        <a class="dropdown-item " routerLink="/tuja" data-toggle="collapse"
                                                data-target="#navbarSupportedContent">Tuja si Chiparos</a>
                                        <a class="dropdown-item" routerLink="/brazi" data-toggle="collapse"
                                                data-target="#navbarSupportedContent">Brazi si Pini</a>
                                        <a class="dropdown-item" routerLink="/ienupar" data-toggle="collapse"
                                                data-target="#navbarSupportedContent">Ienupar</a>
                                        <a class="dropdown-item" routerLink="/flori" data-toggle="collapse"
                                                data-target="#navbarSupportedContent">Flori</a>
                                        <a class="dropdown-item" routerLink="/diverse" data-toggle="collapse"
                                                data-target="#navbarSupportedContent">Diverse</a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" download="CATALOG"
                                                href="assets\catalog\Catalog.xlsx">Descarca
                                                ultimul
                                                Catalog</a>


                                </div>
                        </li>

                        <li class="nav-item" data-toggle="collapse" data-target="#navbarSupportedContent">
                                <a class="nav-link" routerLink="/about">Despre</a>
                        </li>
                        <li class="nav-item" data-toggle="collapse" data-target="#navbarSupportedContent">
                                <a class="nav-link" routerLink="/foto">Galerie</a>
                        </li>
                        <li class="nav-item" data-toggle="collapse" data-target="#navbarSupportedContent">
                                <a class="nav-link" routerLink="/contact">Contact</a>
                        </li>
                        <li class="nav-item " data-toggle="collapse" data-target="#navbarSupportedContent">
                                <a class="nav-link" href="tel:0733604176" id='navsuna'>
                                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-telephone-plus"
                                                fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd"
                                                        d="M3.925 1.745a.636.636 0 0 0-.951-.059l-.97.97c-.453.453-.62 1.095-.421 1.658A16.47 16.47 0 0 0 5.49 10.51a16.47 16.47 0 0 0 6.196 3.907c.563.198 1.205.032 1.658-.421l.97-.97a.636.636 0 0 0-.06-.951l-2.162-1.682a.636.636 0 0 0-.544-.115l-2.052.513a1.636 1.636 0 0 1-1.554-.43L5.64 8.058a1.636 1.636 0 0 1-.43-1.554l.513-2.052a.636.636 0 0 0-.115-.544L3.925 1.745zM2.267.98a1.636 1.636 0 0 1 2.448.153l1.681 2.162c.309.396.418.913.296 1.4l-.513 2.053a.636.636 0 0 0 .167.604L8.65 9.654a.636.636 0 0 0 .604.167l2.052-.513a1.636 1.636 0 0 1 1.401.296l2.162 1.681c.777.604.849 1.753.153 2.448l-.97.97c-.693.693-1.73.998-2.697.658a17.471 17.471 0 0 1-6.571-4.144A17.47 17.47 0 0 1 .639 4.646c-.34-.967-.035-2.004.658-2.698l.97-.969zM12.5 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H12V.5a.5.5 0 0 1 .5-.5z" />
                                                <path fill-rule="evenodd"
                                                        d="M12 3.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H13v2.5a.5.5 0 0 1-1 0v-3z" />
                                        </svg>
                                        Sunati-ma!
                                </a>
                        </li>
                </ul>

        </div>
</nav>